import { Box, Typography } from '@branch-messenger/willow-ui'
import {
  BankNoteIncrease,
  CreditCard02,
  InfoCircle,
  ReceiptDollar,
} from '@branch-messenger/willow-ui/icons'
import { useMemo } from 'react'

import DebitCardsStacked from '@/assets/illustrations/debit-cards-stacked.svg?react'
import { FeatureListProps, FeaturesList } from '@/components/features-list'
import { PageTitle } from '@/components/page-title'
import { usePayoutFee } from '@/hooks/usePayoutFee'
import { useOrg } from '@/selectors/organization'

export const DebitCardInformation = () => {
  const {
    data: { orgName },
  } = useOrg()
  const { formattedFee } = usePayoutFee()

  const debitCardInfo = useMemo(() => {
    return [
      {
        title:
          'Connecting your card to Branch Direct triggers payments to that card.',
        icon: BankNoteIncrease,
      },
      {
        title: 'Card must be an active debit card.',
        icon: CreditCard02,
      },
      {
        title:
          formattedFee === 'Free'
            ? 'There are no fees for payments to your connected debit card'
            : `The convenience fee incurred on each payment is ${formattedFee}`,
        icon: ReceiptDollar,
      },
      {
        title:
          'You can stop payments or update your payment method at any time.',
        icon: InfoCircle,
      },
    ] satisfies FeatureListProps['features']
  }, [formattedFee])

  return (
    <Box $display="flex" $direction="column" $gap={6} $align="flex-start">
      <Box $display="flex" $justify="center" $fullWidth>
        <DebitCardsStacked />
      </Box>
      <Box $display="flex" $direction="column" $gap={4} $align="flex-start">
        <PageTitle>Let’s get your debit card connected.</PageTitle>
        <Typography>
          Once your debit card is connected, your {orgName} payments will start
          flowing.
        </Typography>
      </Box>
      <FeaturesList features={debitCardInfo} />
    </Box>
  )
}
